import Vue from 'vue'
import vClickOutside from 'v-click-outside'

let isInstalled = false
if (!isInstalled) {
  isInstalled = true
  Vue.directive('click-outside', vClickOutside.directive)
}
